/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import ReviewListState from '../states/ReviewListState';
import { extend } from 'flarum/common/extend';

export default function () {
	extend(app, 'mount', function () {
		// The cached review list behind the index page and the slideout pane.
		this.reviews = new ReviewListState({});
	});
}
